export default {"src":"/_next/static/media/settings.9340ca1b.svg","height":24,"width":24};